import { useState, useCallback } from "react";

import { validate } from "../utils/validation";

export const useForm = ({ form, rules, onSubmit }) => {
  const [formValue, setFormValue] = useState(form);
  const [formErrors, setFormErrors] = useState({});

  const setFormFieldValue = (field) => (value) => {
    setFormValue({ ...formValue, [field]: value });
    setFormErrors({ ...formErrors, [field]: undefined });
  };

  const submitWithValidation = useCallback(() => {
    const validationErrors = validate(formValue, rules);
    setFormErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    onSubmit();
  }, [formValue, rules, onSubmit]);

  return {
    formValue,
    formErrors,
    setFormValue,
    setFormFieldValue,
    onFormSubmit: submitWithValidation,
  };
};
